module.exports = __webpack_public_path__ + "src/assets/img/cleaver.6190b50f.svg";